module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-2-36f581728d93d8d11c34ffb8f6e11368.svg";